import Menu from '~/src/common/components/Menu';
import { type Navigation } from '~/src/common/components/Navigation/types';
import I18n from '~/src/common/services/I18n';

import { getCategoryPageLink } from '../utils';

interface Props {
  navigation: Navigation;
  isActiveID: (id: string) => boolean;
  onLinkClick: (id: string) => void;
}

const CategoryMenuUnknown = ({ navigation, isActiveID, onLinkClick }: Props) => {
  // La liste des catégories -- toutes familles confondues
  const categories = navigation.families.flatMap(fam => fam.categories);

  // Tracking sur les catégories racines
  const handleCategoryClick = (item: { id: string }) => {
    onLinkClick(item.id);
  };

  return (
    <>
      <Menu $desktop="primary" $mobile="primary" $visibility="desktop">
        <Menu.Title>{I18n.t('category.menu.unknown.title')}</Menu.Title>
      </Menu>
      <Menu $desktop="secondary" $mobile="primary">
        {categories.map(cat => (
          <Menu.Entry
            key={cat.id}
            isActive={isActiveID(cat.id)}
            href={getCategoryPageLink(cat)}
            onClick={() => handleCategoryClick(cat)}>
            {cat.name}
          </Menu.Entry>
        ))}
      </Menu>
    </>
  );
};

export default CategoryMenuUnknown;
